import { gql } from '@apollo/client'

export const MUTATION_REMOVE_TAGS_FOR_CASE_ITEMS = gql`
  mutation mutationRemoveTagsForCaseItems(
    $input: RemoveTagsForCaseItemsInput!
  ) {
    removeTagsForCaseItems(input: $input)
  }
`
